import { liveFeed } from "@/mocks/home";

export default function LiveFeed() {
  return (
    <section id="feed" className="w-full px-4 md:px-10 py-14 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-12">
        <div>
          <span className="text-xs md:text-sm tracking-[0.3em] text-primary-600 uppercase">
            Live Timeline
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            实时快讯流
          </h2>
          <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">
            按时间线排列的今日更新，越靠上越新。每条都带来源与可信度标注，
            实时追新料时不用来回切换。
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <span className="inline-flex items-center gap-2 px-3 py-2 rounded-full bg-secondary-100 text-secondary-900 text-xs md:text-sm whitespace-nowrap">
            <i className="ri-radar-line text-base" />
            每分钟刷新
          </span>
        </div>
      </div>

      <div className="relative">
        <span className="absolute left-[7px] md:left-[95px] top-2 bottom-2 w-px bg-foreground-950/12" />
        <div className="flex flex-col">
          {liveFeed.map((item) => (
            <article key={item.title} className="relative flex gap-4 md:gap-6 pb-8 last:pb-0">
              <div className="hidden md:block w-[72px] shrink-0 pt-4 text-right">
                <span className="font-heading text-base font-bold text-foreground-800">
                  {item.time}
                </span>
              </div>

              <div className="relative shrink-0 pt-5">
                <span
                  className={`block w-[15px] h-[15px] rounded-full ring-4 ring-background-50 ${
                    item.live ? "bg-primary-500" : "bg-foreground-300"
                  }`}
                />
                {item.live && (
                  <span className="absolute inset-0 w-[15px] h-[15px] rounded-full bg-primary-500 animate-pulse-soft" />
                )}
              </div>

              <div className="flex-1 min-w-0 rounded-lg border hairline bg-background-50 hover:bg-background-100/70 transition-colors px-4 md:px-6 py-4 md:py-5">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-2 mb-2">
                  <span className="md:hidden font-heading text-sm font-bold text-foreground-800">
                    {item.time}
                  </span>
                  <span className="px-2.5 py-1 rounded-md bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                  {item.live && (
                    <span className="inline-flex items-center gap-1.5 text-xs text-primary-600">
                      <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse-soft" />
                      刚刚更新
                    </span>
                  )}
                  <span className="ml-auto inline-flex items-center gap-1.5 text-xs text-foreground-500 whitespace-nowrap">
                    <i className="ri-fire-line text-sm" />
                    {item.heat}
                  </span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold leading-snug text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-arrow-right-up-line text-sm" />
                    查看时间线
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-bookmark-line text-sm" />
                    加入追新
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>

      <div className="mt-10 flex justify-center">
        <a
          href="#today"
          className="inline-flex items-center gap-2 px-7 py-4 rounded-md border hairline text-foreground-800 text-sm md:text-base font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
        >
          查看今日新料图文版
          <i className="ri-arrow-down-line text-lg" />
        </a>
      </div>
    </section>
  );
}